/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_OverlineInputs */

const en_of_landing_overline = /** @type {(inputs: Of_Landing_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The KerjaBareng virtual office`)
};

const id_of_landing_overline = /** @type {(inputs: Of_Landing_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kantor virtual KerjaBareng`)
};

/**
* | output |
* | --- |
* | "The KerjaBareng virtual office" |
*
* @param {Of_Landing_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_overline = /** @type {((inputs?: Of_Landing_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_overline(inputs)
	return en_of_landing_overline(inputs)
});